import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "container-fluid" };
var _hoisted_2 = {
    class: "card my-5 mx-auto",
    style: { "max-width": "560px" }
};
var _hoisted_3 = { class: "card-body py-4" };
var _hoisted_4 = { class: "nav nav-tabs" };
var _hoisted_5 = { class: "nav-item" };
var _hoisted_6 = { class: "nav-item" };
var _hoisted_7 = { key: 0 };
var _hoisted_8 = { class: "input-group" };
var _hoisted_9 = { class: "input-group" };
var _hoisted_10 = { class: "input-group" };
var _hoisted_11 = { class: "input-group" };
var _hoisted_12 = { key: 0 };
var _hoisted_13 = { class: "input-group mt-3" };
var _hoisted_14 = { key: 1 };
import { registerClient } from '@/api/public/client';
import router from '@/routes';
import { useAuthStore } from '@/stores/authStore';
import { getProfileData } from '@/api/auth';
import { notify } from '@/utils/toast';
import { onMounted, ref } from 'vue';
import { toast } from 'vue3-toastify';
import CountrySelect from '@/components/CountrySelect.vue';
import UpdatePassword from '@/components/UpdatePassword.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProfilePage',
    setup: function (__props) {
        var _this = this;
        var register = ref({
            username: '',
            firstname: '',
            lastname: '',
            birthday: '',
            email: '',
            phone: '',
            address: '',
            state: '',
            countryId: '',
            country: null,
        });
        var tabSel = ref(0);
        var auth = useAuthStore();
        var emailError = ref('');
        var countryRef = ref();
        var handleRegister = function () { return __awaiter(_this, void 0, void 0, function () {
            var record, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, registerClient(register.value)];
                    case 1:
                        record = _a.sent();
                        console.log(record);
                        if (record.status === 201) {
                            if (auth.hasOrder()) {
                                router.push({ name: 'OrderPage' });
                            }
                            else {
                                router.push({ name: 'Dashboard' });
                            }
                        }
                        else {
                            notify('Ocurrio un error en el registro', 'danger', toast.POSITION.TOP_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error al registrar:', error_1);
                        notify('Ocurrio un error en el registro. Fatal error.', 'danger', toast.POSITION.TOP_CENTER);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var getProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getProfileData()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            register.value = response.data;
                            countryRef.value.setCountry(register.value.countryId);
                            //console.log('Perfil cargado:', savedData.value, jsonData);
                        }
                        else {
                            console.error('Error al cargar el perfil');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error al cargar el perfil', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var validateEmail = function () {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(register.value.email)) {
                emailError.value = 'Por favor, introduce un correo electrónico válido.';
            }
            else {
                emailError.value = '';
            }
        };
        onMounted(function () {
            getProfile();
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header" }, " Editar perfil ", -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("ul", _hoisted_4, [
                            _createElementVNode("li", _hoisted_5, [
                                _createElementVNode("a", {
                                    class: _normalizeClass({ 'nav-link': true, 'active': tabSel.value === 0 }),
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (tabSel.value = 0); })
                                }, "Información", 2)
                            ]),
                            _createElementVNode("li", _hoisted_6, [
                                _createElementVNode("a", {
                                    class: _normalizeClass({ 'nav-link': true, 'active': tabSel.value === 1 }),
                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (tabSel.value = 1); })
                                }, "Cambiar contraseña", 2)
                            ])
                        ]),
                        (tabSel.value === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "mt-2" }, "Datos Personales", -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, [
                                    _createElementVNode("small", null, "Nombre(s) *")
                                ], -1)),
                                _createElementVNode("div", _hoisted_8, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((register.value.firstname) = $event); })
                                    }, null, 512), [
                                        [_vModelText, register.value.firstname]
                                    ])
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, [
                                    _createElementVNode("small", null, "Apellidos *")
                                ], -1)),
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((register.value.lastname) = $event); })
                                    }, null, 512), [
                                        [_vModelText, register.value.lastname]
                                    ])
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, [
                                    _createElementVNode("small", null, "Fecha de nacimiento *")
                                ], -1)),
                                _createElementVNode("div", _hoisted_10, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        type: "date",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((register.value.birthday) = $event); })
                                    }, null, 512), [
                                        [_vModelText, register.value.birthday]
                                    ])
                                ]),
                                _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
                                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mt-4" }, "Datos de contacto", -1)),
                                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, [
                                    _createElementVNode("small", null, "Correo electrónico *")
                                ], -1)),
                                _createElementVNode("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((register.value.email) = $event); }),
                                        placeholder: "Correo electrónico",
                                        onInput: validateEmail
                                    }, null, 544), [
                                        [_vModelText, register.value.email]
                                    ])
                                ]),
                                (emailError.value)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(emailError.value), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(CountrySelect, {
                                        modelValue: register.value.country,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((register.value.country) = $event); }),
                                        ref_key: "countryRef",
                                        ref: countryRef
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", { class: "row justify-content-center px-4 pt-3" }, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        onClick: handleRegister
                                    }, "Actualizar")
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (tabSel.value === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(UpdatePassword)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
